import React from 'react'
import { BannerCourseItem, AdvModelItem } from './publicComponent'

function AdvModelOne(props) {
    const { model } = props
    return (
        <div className={`public_model`} >
            {/* {model.Headline && model.Headline.length > 0 ? <p className='public_model_big_title'>{model.Headline}</p> : ''}
            {model.Subheading && model.Subheading.length > 0 ? <p className='public_model_little_title'>{model.Subheading}</p> : ''} */}
            <div className='adv_public_wrap'>
                <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[0] : {}} width="284" height="380" imargin="" />
                <div className='adv_item_public_margin_left'>
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[1] : {}} width="436" height="246" imargin="" />
                    <ul className='middle_left_ul'>
                        <li>
                            <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[2] : {}} mime="true" width="208" height="114" imargin="adv_item_public_margin_top" />
                        </li>
                        <li className='adv_item_public_margin_left'>
                            <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[3] : {}} mime="true" width="208" height="114" imargin="adv_item_public_margin_top" />
                        </li>
                    </ul>
                </div>
                <div className='adv_item_public_margin_left'>
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[4] : {}} width="212" height="380" imargin="" />
                </div>
                <ul className='adv_item_public_margin_left' style={{ width: '208px' }}>
                    <li>
                        <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[5] : {}} mime="true" width="208" height="114" imargin="" />
                    </li>
                    <li>
                        <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[6] : {}} mime="true" width="208" height="114" imargin="adv_item_public_margin_top" />
                    </li>
                    <li>
                        <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[7] : {}} mime="true" width="208" height="114" imargin="adv_item_public_margin_top" />
                    </li>
                </ul>
            </div>
        </div>
    )
}

function AdvModelTwo(props) {
    const { model } = props
    return (
        <div className={`public_model`} >
            {/* {model.Headline && model.Headline.length > 0 ? <p className='public_model_big_title'>{model.Headline}</p> : ''}
            {model.Subheading && model.Subheading.length > 0 ? <p className='public_model_little_title'>{model.Subheading}</p> : ''} */}
            <div className='adv_public_wrap'>
                <div>
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[0] : {}} sort="1" width="300" height="180" imargin="" />
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[1] : {}} sort="2" width="300" height="180" imargin="adv_item_public_margin_top" />
                </div>
                <div className={`adv_item_public_margin_left adv_item_public_margin_right`}>
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[2] : {}} sort="3" width="560" height="380" imargin="" />
                </div>
                <div>
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[3] : {}} sort="4" width="300" height="180" imargin="" />
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[4] : {}} sort="5" width="300" height="180" imargin="adv_item_public_margin_top" />
                </div>
            </div>
        </div>
    )
}


function AdvModelThree(props) {
    const { model } = props
    return (
        <div className={`public_model`} >
            {/* {model.Headline && model.Headline.length > 0 ? <p className='public_model_big_title'>{model.Headline}</p> : ''}
            {model.Subheading && model.Subheading.length > 0 ? <p className='public_model_little_title'>{model.Subheading}</p> : ''} */}
            <div className='adv_public_wrap'>
                <div>
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[0] : {}} sort='1' width="380" height="380" imargin="" />
                </div>
                <div className={`adv_item_public_margin_left adv_item_public_margin_right`}>
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[1] : {}} sort='2' width="380" height="180" imargin="" />
                    <div className={`public_flex adv_item_public_margin_top`}>
                        <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[2] : {}} sort='3' width="180" height="180" imargin="" />
                        <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[3] : {}} sort='4' width="180" height="180" imargin="adv_item_public_margin_left" />
                    </div>
                </div>
                <div>
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[4] : {}} sort='5' width="400" height="180" imargin="" />
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[5] : {}} sort='6' width="400" height="180" imargin="adv_item_public_margin_top" />
                </div>
            </div>
        </div>
    )
}

function AdvModelFour(props) {
    const { model } = props
    return (
        <div className={`public_model`} >
            {/* {model.Headline && model.Headline.length > 0 ? <p className='public_model_big_title'>{model.Headline}</p> : ''}
            {model.Subheading && model.Subheading.length > 0 ? <p className='public_model_little_title'>{model.Subheading}</p> : ''} */}
            <div className='adv_public_wrap'>
                <div>
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[0] : {}} sort='1' width="208" height="114" imargin="" mime="true" ></AdvModelItem>
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[1] : {}} sort='2' width="208" height="114" imargin="adv_item_public_margin_top" mime="true" ></AdvModelItem>
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[2] : {}} sort='3' width="208" height="114" imargin="adv_item_public_margin_top" mime="true" ></AdvModelItem>
                </div>
                <div className='adv_item_public_margin_left'>
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[3] : {}} sort='4' width="212" height="380" imargin="" ></AdvModelItem>
                </div>
                <div className={`adv_item_public_margin_left adv_item_public_margin_right`}>
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[4] : {}} sort='5' width="436" height="246" imargin="" ></AdvModelItem>
                    <div className={`adv_item_public_margin_top public_flex`}>
                        <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[5] : {}} sort='6' width="208" height="114" mime="true" imargin="" ></AdvModelItem>
                        <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[6] : {}} sort='7' width="208" height="114" imargin="adv_item_public_margin_left" ></AdvModelItem>
                    </div>
                </div>
                <div className='adv_item_public_margin_left'>
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[7] : {}} sort='8' width="284" height="380" imargin="" ></AdvModelItem>
                </div>
            </div>
        </div>
    )
}

function AdvModelFive(props) {
    const { model } = props
    return (
        <div className={`public_model`} >
            {/* {model.Headline && model.Headline.length > 0 ? <p className='public_model_big_title'>{model.Headline}</p> : ''}
            {model.Subheading && model.Subheading.length > 0 ? <p className='public_model_little_title'>{model.Subheading}</p> : ''} */}
            <div className='adv_public_wrap'>
                <div>
                    <AdvModelItem model={model.Imgdetaillist ? model.Imgdetaillist[0] : {}} sort='1' width="1200" height="160" imargin="" mime="true" ></AdvModelItem>
                </div>
            </div>
        </div>
    )
}

function BannerModelOne(props) {
    const { model } = props
    return (
        <div className={`public_model`} >
            <div className='model_wrap'>
                {/* <p className='public_model_big_title'>{model.Headline || '默认标题'}</p>
                <p className='public_model_little_title'>{model.Subheading || '默认标题'}</p> */}
                <div className='content_public_item_wrap'>
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[0] : {}} />
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[1] : {}} imargin="content_public_margin_left" />
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[2] : {}} imargin="content_public_margin_left" />
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[3] : {}} imargin="content_public_margin_left" />
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[4] : {}} />
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[5] : {}} imargin="content_public_margin_left" />
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[6] : {}} imargin="content_public_margin_left" />
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[7] : {}} imargin="content_public_margin_left" />
                </div>
            </div>
        </div>
    )
}

function BannerModelTwo(props) {
    const { model } = props
    return (
        <div className={`public_model`} >
            <div className='model_wrap'>
                {/* <p className='public_model_big_title'>{model.Headline || '默认标题'}</p>
                <p className='public_model_little_title'>{model.Subheading || '默认标题'}</p> */}
                <div className='content_public_item_wrap'>
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[0] : {}} />
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[1] : {}} imargin="content_public_margin_left" />
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[2] : {}} imargin="content_public_margin_left" />
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[3] : {}} imargin="content_public_margin_left" />
                </div>
            </div>
        </div>
    )
}

function BannerModelThree(props) {
    const { model } = props
    return (
        <div className={`public_model`} >
            <div className='model_wrap'>
                {/* <p className='public_model_big_title'>{model.Headline || '默认标题'}</p>
                <p className='public_model_little_title'>{model.Subheading || '默认标题'}</p> */}

                <div className='public_flex content_three_adv_wrap'>
                    <AdvModelItem model={model.Imgdetaillist[0] || {}} width="590" height="160" imargin="adv_item_public_margin_right" />
                    <AdvModelItem model={model.Imgdetaillist[1] || {}} width="590" height="160" imargin="" />
                </div>
                <div className='content_public_item_wrap'>
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[0] : {}} />
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[1] : {}} imargin="content_public_margin_left" />
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[2] : {}} imargin="content_public_margin_left" />
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[3] : {}} imargin="content_public_margin_left" />
                </div>
            </div>
        </div>
    )
}


function BannerModelFour(props) {
    const { model } = props
    return (
        <div className={`public_model`} >
            <div className='model_wrap'>
                {/* <p className='public_model_big_title'>{model.Headline || '默认标题'}</p>
                <p className='public_model_little_title'>{model.Subheading || '默认标题'}</p> */}

                <div className='public_flex content_three_adv_wrap'>
                    <AdvModelItem model={model.Imgdetaillist[0] || {}} width="1200" height="160" imargin="" />
                </div>
                <div className='content_public_item_wrap'>
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[0] : {}} />
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[1] : {}} imargin="content_public_margin_left" />
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[2] : {}} imargin="content_public_margin_left" />
                    <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[3] : {}} imargin="content_public_margin_left" />
                </div>
            </div>
        </div>
    )
}

function BannerModelFive(props) {
    const { model } = props
    return (
        <div className={`public_model`} >
            <div className='model_wrap'>
                {/* <p className='public_model_big_title'>{model.Headline || '默认标题'}</p>
                <p className='public_model_little_title'>{model.Subheading || '默认标题'}</p> */}

                <div className='content_public_item_wrap public_flex'>
                    <div>
                        <AdvModelItem model={model.Imgdetaillist[0] || {}} width="285" height="583" imargin="" />
                    </div>
                    <div className='content_public_margin_left'>
                        <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[0] : {}} />
                        <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[1] : {}} imargin="content_public_margin_left" />
                        <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[2] : {}} imargin="content_public_margin_left" />
                        <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[3] : {}} imargin="" />
                        <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[4] : {}} imargin="content_public_margin_left" />
                        <BannerCourseItem subject={model.Coursedetaillist ? model.Coursedetaillist[5] : {}} imargin="content_public_margin_left" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export {
    AdvModelOne,
    AdvModelTwo,
    AdvModelThree,
    AdvModelFour,
    AdvModelFive,
    BannerModelOne,
    BannerModelTwo,
    BannerModelThree,
    BannerModelFour,
    BannerModelFive
}


// WEBPACK FOOTER //
// ./src/features/home/model.js